/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type { GetServerInfoResponse } from "./models";
import { getServerInfoResponseSchema } from "./schemas";

export class PiserverApiClient {
  constructor(private caller: ApiCaller) {}

  async getServerInfo(timeout?: number): Promise<GetServerInfoResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.piserver.v1.infos.get",
        variables: {},
      },
      "getServerInfo",
      {},
      { schema: getServerInfoResponseSchema, timeout },
    );
  }
}
